"use client";

import { useContext } from "react";
import { ConnectionsContext } from "./provider";

export function useConnections() {
  const context = useContext(ConnectionsContext);
  if (context === undefined) {
    throw new Error("useConnections must be used within a ConnectionsProvider");
  }
  return context;
}

export function useInboxes() {
  const { inboxes, inboxGroups, inboxesLoading, inboxesError, refetchConnections } =
    useConnections();
  return {
    inboxes,
    groups: inboxGroups,
    loading: inboxesLoading,
    error: inboxesError,
    refetch: refetchConnections,
  };
}
